// Permission name constants — must match the backend PERMISSIONS keys (permissions.js
// in the proxy). The frontend never hardcodes roles; it checks these permission
// strings against the set returned by GET /my-permissions.
export const PERMISSIONS = {
  VIEW_DASHBOARDS: "VIEW_DASHBOARDS",
  VIEW_ANALYTICS: "VIEW_ANALYTICS",
  GENERATE_REPORTS: "GENERATE_REPORTS",
  ACCESS_AI_INSIGHTS: "ACCESS_AI_INSIGHTS",
  START_ASSESSMENTS: "START_ASSESSMENTS",
  MANAGE_CONFIGURATION: "MANAGE_CONFIGURATION",
  MANAGE_ORG_STRUCTURE: "MANAGE_ORG_STRUCTURE",
  MANAGE_FORMS: "MANAGE_FORMS",
  MANAGE_USERS_ROLES: "MANAGE_USERS_ROLES",
  MANAGE_PLATFORM_SETTINGS: "MANAGE_PLATFORM_SETTINGS",
  // EcoPrism staff only (injected by the proxy when the caller is in the
  // ecoprismadmins table). Gates the Organisations provisioning pages.
  PLATFORM_STAFF: "PLATFORM_STAFF",
};
